import React, { Component, useRef, createRef} from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import MapRenameDwLayer from '../maps/MapRenameDwLayer';
import MapStyleDwLayer from '../maps/MapStyleDwLayer';
import MapDwForm from '../maps/MapDwForm';
import { IColorStyle } from '../../data/Query';

// Interface with parent
//
interface ModalConfigureLayerProps {
  show: boolean,
  onHandleClose: Function,
  onSaveNewLayerName: Function,
  layer: any,
  dwDefinition: any,
  configUpdated: Function,
  layerStyleUpdated: Function,
  updateDwLayers: Function
  definitionWrappers: any,
}

interface ModalConfigureLayerState {
  layerTitle: string,
  layerProperties: any,
  storedDefinitionId: any,
}

class ModalConfigureLayer extends Component<ModalConfigureLayerProps, ModalConfigureLayerState> {
  private childref: any;
  private dwLayerStyleRef: any;
  constructor(props: any) {
    super(props);

    // Bind 'this' to functions so that 'this' is available inside each function
    //
    this.handleClose = this.handleClose.bind(this);
    this.handleLayerNameChange = this.handleLayerNameChange.bind(this);
    this.handleFormChangeInput = this.handleFormChangeInput.bind(this);
    this.handleOnSaveNewLayerName = this.handleOnSaveNewLayerName.bind(this);
    this.dwUpdateCallback = this.dwUpdateCallback.bind(this)
    console.log("props", props)
    let layerTitle = "layerTitle"; 
    if (props.layer.values_.title){
      layerTitle = props.layer.values_.title;
    }
    this.state = {
      layerTitle: layerTitle,
      layerProperties: props,
      storedDefinitionId: null
    };
    this.childref = React.createRef();
    this.dwLayerStyleRef = React.createRef();
  }

  handleClose() {
    const { onHandleClose } = this.props;
    onHandleClose();
  }

  applyLayerReConfig() {
    console.log("020122 applyLayerReConfig()")
    // Apply layer name
    console.log("020122 this.state.layerTitle", this.state.layerTitle);
    this.props.layer.set("title",this.state.layerTitle)
    const { onSaveNewLayerName } = this.props;
    onSaveNewLayerName(this.props.layer);
    // Apply Data Source
    console.log("020122 this.state", this.state);
    console.log("020122 this.props", this.props);
    console.log("020122 this.childref", this.childref);
    console.log("020122 this.dwLayerStyleRef", this.dwLayerStyleRef);
    //  0) does this layer have a config? (is it a DW layer) 
    if (this.props.layer.dwdataChartType === "dwLayer"){
      // trigger mapDwForm.tsx > applyConfig();
      this.childref.current.applyConfig();
      this.dwLayerStyleRef.current.onSave();
    }
    //  dwUpdateCallback(newConfig);
    // ...
    // Apply Layer Style
    // ...
  }


  async handleLayerNameChange(e: any) {
    console.log("handleLayerNameChange > e", e)
    const { onSaveNewLayerName } = this.props;

    console.log("handleLayerNameChange > this.state.layerTitle", this.state.layerTitle)
    const layerTitle = this.state.layerTitle;

    console.log("handleLayerNameChange > this.state.layerProperties", this.state.layerProperties)
    this.state.layerProperties.layer.set("title", layerTitle);

    console.log("handleLayerNameChange > ABOUT TO: onSaveNewLayerName()")
    onSaveNewLayerName();
  }

  async handleOnSaveNewLayerName(e: any) {
    console.log("e", e)
    const { onSaveNewLayerName } = this.props;
    onSaveNewLayerName(this.props.layer);
  }

  onChangeDefinition(e: any) {
    // eslint-disable-next-line
    let wrapper = this.state.layerProperties.definitionWrappers.find((d: any) => d.id == e.target.value);

    console.log('onChangeDefinition e.target.value', e.target.value);
    console.log('onChangeDefinition this.state', this.state);
    console.log('onChangeDefinition wrapper', wrapper);

    // need to update this.state.layerProperties.layer.dwdataQueryConfig.definitionId 
    //    - but should reset the rest of the config.
    var layerPropsForUpdate = { ...this.state.layerProperties }
    layerPropsForUpdate.layer.dwdataQueryConfig.definitionId = wrapper.id;

    this.setState({
      layerProperties: layerPropsForUpdate,
    });
  }

  // Use the new name from form to set layerTitle
  //
  handleFormChangeInput(_newName: any) {
    console.log("handleFormChangeInput > _newName", _newName)
    this.setState({
      layerTitle: _newName,
    });
  }

  dwUpdateCallback(newConfig: any) {
    const { configUpdated, updateDwLayers } = this.props;

    console.log("020122 dwUpdateCallback() newConfig", newConfig);

    this.state.layerProperties.layer.dwdataQueryConfig = newConfig;

    configUpdated(newConfig, this.state.layerProperties.layer);

    //updateDwLayers();

    this.setState({
      storedDefinitionId: this.state.layerProperties.layer.dwdataQueryConfig.definitionId
    });
  }

  colorUpdatedCallback(colorStyle: any, lowColor: any, highPoint: any, lowPoint: any, maxClass:any, minClass:any){
    const { layerStyleUpdated } = this.props;
    console.log("C030421 colorStyle, lowColor, highPoint, lowPoint, this.state.layerProperties.layer, maxClass, minClass",colorStyle, lowColor, highPoint, lowPoint, this.state.layerProperties.layer, maxClass, minClass)
    layerStyleUpdated(colorStyle, lowColor, highPoint, lowPoint, this.state.layerProperties.layer, maxClass, minClass);
  }

  render() {
    const { show } = this.props;
    let dwStyleHTML;
    let dwFormHTML;
    let dwDefHTML;
    let dwConfigHTML;
    let _wrapper;
    let _dwDefinition;
 
    if ("dwdataQueryConfig" in this.state.layerProperties.layer) {
      let configToUse: any = null;
      if (!this.state.storedDefinitionId) {
        this.setState({
          storedDefinitionId: this.state.layerProperties.layer.dwdataQueryConfig.definitionId
        });
      }
      if (this.state.layerProperties.layer.dwdataQueryConfig.definitionId === this.state.storedDefinitionId) {
        configToUse = this.state.layerProperties.layer.dwdataQueryConfig;
      }

      _wrapper = this.props.definitionWrappers.find((d: any) => d.id == this.state.layerProperties.layer.dwdataQueryConfig.definitionId);
      _dwDefinition = _wrapper.definition

      dwDefHTML = <Form>
        <Form.Group>
          <Form.Label>Data Source</Form.Label>
          {/*console.log("_dwDefinition", _dwDefinition)*/}
          <Form.Control as="select" name="chart-type"
            onChange={this.onChangeDefinition.bind(this)}
            defaultValue={_wrapper ? _wrapper.id : undefined}>
            <option value={_wrapper ? _wrapper.id : undefined}>{_wrapper ? _wrapper.name : "Select a data source definition"}</option>
            {this.props.definitionWrappers.map((d: any) => <option key={d.id} value={d.id}>{d.name}</option>)}
          </Form.Control>
        </Form.Group>
      </Form>;

      dwFormHTML = <Form>
        <MapDwForm
          ref={this.childref}
          wrapper={_wrapper}
          definition={_dwDefinition}
          queryConfig={configToUse}
          saveConfig={(queryConfig: any) => this.dwUpdateCallback(queryConfig)}>
        </MapDwForm>
      </Form>;

      dwConfigHTML = <div className="mb-3 p-3 bg-dark">
            {dwDefHTML}
            {dwFormHTML}
          </div>

      dwStyleHTML = <div className="mb-3 p-3 bg-dark">
        <MapStyleDwLayer
          ref={this.dwLayerStyleRef}
          layer={this.state.layerProperties.layer}
          definition={_dwDefinition}
          saveColor={(colorStyle: any, lowColor: any, highPoint: any, lowPoint: any, max:any, min:any) => this.colorUpdatedCallback(colorStyle, lowColor, highPoint, lowPoint, max, min)}
        />
      </div>;
    } else {
      dwConfigHTML = null;
    }

    return (
      <Modal
        show={show}
        centered
        onHide={this.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Configure Layer</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3 p-3 bg-dark">
          <MapRenameDwLayer
            handleFormChangeInputFromComponent={(v: any) => this.handleFormChangeInput(v)} // returns new layer name
            handleLayerNameChangeFromComponent={(e: any) => this.handleLayerNameChange(e)} // returns save new layer event 
            handleOnSaveNewLayerName={(e: any) => this.handleOnSaveNewLayerName(e)}
            layer={this.state.layerProperties.layer}
          />
          </div>
          {dwConfigHTML}
          {dwStyleHTML}
        </Modal.Body>
        <Modal.Footer>
          <Button className="mt-2" variant="secondary" onClick={this.handleClose}>Close</Button>
          <Button className="mt-2" variant="primary" onClick={() => this.applyLayerReConfig()}>Apply</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ModalConfigureLayer;
